module.exports = __webpack_public_path__ + "img/svg_en.11657d22.svg";